import { Api } from '../services/api';

export function forgetPasswordRequest({ email }) {
  return Api.post('/admins/reset/password/sendmail', { email }, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
